import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Head } from "./style";

export function MyPageHead({ className, title }) {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <Head className={className}>
      <img onClick={goBack} src="/img/arrowBack.svg" alt="arrow back" />
      <h1>{title}</h1>
    </Head>
  );
}
